<script>
	import Data from '../States/Data';
	import Helper from '../Models/Helper';
	import Search from '../Models/Search';
	import Slider from '../States/Slider';
	import Suggest from './Search/Suggest.svelte';

	export let index = 0;

	let input = {};
	let content = {};
	let properties = {};
	let version = {};
	let mapping = {};
	let unique = {};
	let active = false;
	let initialized = false;
	let query = '';
	let last_input = '';
	let expand = [];
	let searching = false;
	let timeout = 0;
	let results = [];

	async function init() {
		Helper.title('Zoeken');

		version = await Data.relative('version');
		mapping = await Data.absolute('mapping');
		unique = await Data.relative('search/unique');

		if (properties.query) {
			query = properties.query;
			search();
		}

		initialized = true;
	}

	async function search() {
		if (!searching) {
			searching = true;
			const search = new Search(version, unique);
			const config = {expand, exact: true, combination: true};
			results = await search.results(query, config);
			searching = false;
			last_input = '';
		}
	}

	function expandSearch(book) {
		expand.push(book);
		search();
	}

	function verseTotal(results) {
		let total = 0;
		for (const book of results)
			total += book.verses.length;

		return total;
	}

	function toBook(book) {
		const code = book.code;
		const base = jQuery(content);
		const selector = `#search_result_${code}`;
		const element = base.find(selector);
		if (element.length) {
			let top = element.offset().top - base.offset().top + base.scrollTop();
			top -= 75;
			base.animate({scrollTop: top}, 1000 * .5);
		}
	}

	function toReference(verse) {
		verse.reference.proceed = true;
		Slider.route(['reference', [verse.reference, 2, 1]])
		jQuery('div.item[data-verse]').removeClass('active');
		jQuery(`div.item[data-verse="${verse.info.code}"]`).addClass('active');
	}

	function updateSlider(slides) {
		active = Slider.check(index, 'search', properties);
		if (active) {
			properties = Slider.properties(index);
			active = properties.active;

			if (initialized && properties.query) {
				query = properties.query;
				Helper.title(`Zoeken: ${query}`);
				search();
			}
		}
	}

	init();
	Slider.subscribe(updateSlider);
</script>

<style>
	div.box.initial {
		background: var(--box-feature-background-transparent);
	}

	div.box div.content {
		background: transparent;
	}

	div.below-input {
		padding-top: 1em;
	}

	div.search-notice {
		margin-bottom: 2em;
	}

	h3.list.books,
	div.list.books {
		color: var(--tertiary-color);
	}

	div.list.books > .item > div.percentage {
		background: var(--tertiary-background-light);
	}

	div.list.books > .item > div.count {
		position: absolute;
		padding: 0 .5em;
		margin-right: .75em;
		border-radius: .3em;
		right: 0;
		font-size: .9em;
		opacity: .75;
		background: var(--box-background-focus);
	}

	div.list.books > .item div.name i {
		margin-right: .5em;
		opacity: .5;
	}

	div.results h3.solid.list {
		margin-top: 2em;
	}

	div.results div.list {
		margin-bottom: 1.5em;
	}

	div.results div.list > .item {
		font-weight: 400;
		margin: .75em 0;
		padding-bottom: .5em;
	}

	div.results div.list > .item > p {
		font-size: 1.1em;
		line-height: 1.5em;
		width: 90%;
		padding: .25em 0 .75em 0;
		margin: 0;
		border-bottom: 1px solid var(--primary-background-light);
	}

	div.results div.list > .item > i {
		position: relative;
		margin-top: 1em;
		color: var(--secondary-color);
		float: right;
		right: auto;
	}

	div.results div.list > .item > div {
		font-weight: 700;
		color: var(--secondary-color);
		margin-top: .5em;
	}

	div.results div.list > .item > div i {
		margin-right: .5em;
		opacity: .5;
	}

	div.results h3 {
		margin: 0;
	}

	div.button.expand {
		margin-top: .75em;
		text-align: left;
		text-transform: none;
		color: var(--tertiary-color);
	}

	:global(div.box.search div.results span.highlight) {
		font-weight: 700;
		color: var(--tertiary-color);
	}
</style>

<div class="box feature search" class:active class:initial="{!Helper.is(results)}">
	<div class="menu">
		<div class="begin">
			<div class="title">Zoeken</div>
		</div>
		<div class="end">
			<div class="item" on:click="{event => Slider.close()}">
				<i class="fas fa-times"></i>
			</div>
		</div>
	</div>
	<div class="content" bind:this="{content}">
		{#if !Helper.is(results) && !properties.query}
			<h1>Verzen zoeken</h1>
			<p>Je kunt een vers opzoeken door een zoekwoord in het veld hieronder te typen.</p>
		{/if}
		<Suggest host="search" query="{properties.query}"/>
		<div class="below-input">
			{#if Helper.is(results)}
				<div class="notice search-notice">
					<i class="fad fa-info-circle"></i> Er zijn <span>{verseTotal(results)}</span> verzen over <span>"{query}"</span> in de bijbel gevonden.
				</div>
				<h3 class="solid list books">Boeken</h3>
				<div class="solid list books">
					{#each results as book}
						<div class="item" on:click="{event => toBook(book.info.book)}">
							<div class="percentage" style="width: calc({book.percentage}% - .6em);"></div>
							<div class="count">{book.verses.length}x</div>
							<div class="name">
								<i class="fad fa-book"></i> {book.info.book.name}
							</div>
						</div>
					{/each}
				</div>
				<div class="results">
					{#each results as book}
						<h3 id="search_result_{book.info.book.code}" class="solid list">
							<a href="/{book.info.book.uri}/1">{book.info.book.name}</a>
						</h3>
						{#if !book.partial}
							<div class="solid list">
								{#each book.verses as verse}
									<div class="item" data-verse="{verse.info.code}" on:click="{event => toReference(verse)}">
										<p>{@html verse.scripture}</p>
										<div>
											<i class="fad fa-bible"></i>
											{verse.info.verse.name}
										</div>
										<i class="fad fa-chevron-right"></i>
									</div>
								{/each}
							</div>
						{:else}
							<div class="button expand" on:click="{event => expandSearch(book.info.book.code)}">
								<i class="fad fa-info-circle"></i> {book.verses.length} verzen in <span>{book.info.book.name}</span> tonen <i class="fas fa-chevron-down"></i>
							</div>
						{/if}
					{/each}
				</div>
			{:else if !searching && query}
				<div class="notice">
					<i class="fad fa-info-circle"></i> Er zijn geen vermeldingen van <span>"{query}"</span> in de bijbel gevonden.
				</div>
			{/if}
		</div>
	</div>
</div>